<!--  -->
<template>
  <v-card class="background-light-grey" flat rounded="0">
    <v-card-text>
      <!-- New Payment Type -->
      <v-row justify="center">
        <v-col cols="12">
          <h3 class="text-h3 font-weight-regular text-center" name="paymentType">
            <slot name="paymentType"></slot>
          </h3>
          <v-row justify="space-around" class="text-center mx-4 mt-3">
            <v-col cols="12" sm="5" md="4">
              <h4 class="text-h4"><slot name="paymentAmountLabel"></slot></h4>
              <h4 class="font-weight-regular text-h4"><slot name="paymentAmount"></slot></h4>
            </v-col>
            <v-col cols="12" sm="5" md="4">
              <h4 class="text-h4"><slot name="nextPaymentDateLabel"></slot></h4>
              <h4 class="font-weight-regular text-h4"><slot name="nextPaymentDate"></slot></h4>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- Your Billing information -->
      <v-row>
        <v-col cols="12" class="text-center">
          <h3 class="font-weight-regular text-h3"><slot name="billingInformationLabel"></slot></h3>
          <h5 class="font-weight-regular text-h5 py-3"><slot name="description"></slot></h5>
        </v-col>
      </v-row>
      <!-- Mailing Address -->
      <v-row>
        <v-col cols="12" class="text-center">
          <h3 class="font-weight-medium text-h3 py-2"><slot name="mailingAddressLabel"></slot></h3>
          <slot name="address"></slot>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';

const componentOptions: ComponentOptions = {
  name: 'DirectPaymentPlaceHolder',
};

export default defineComponent(componentOptions);
</script>
